<template>
  <div>
    <el-card>
      <el-row :span="24">
        <el-col :span="12">
          <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">添加学员分组</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <!-- <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
          >导出</el-button>-->
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        @selection-change="selectionChange"
      >
        <el-table-column prop="sort" show-overflow-tooltip align="center" width="60" label="序号"></el-table-column>
        <el-table-column prop="name" show-overflow-tooltip label="分组名称"></el-table-column>
        <el-table-column prop="studentCount" show-overflow-tooltip label="人数"></el-table-column>
        <el-table-column prop="updateTime" show-overflow-tooltip label="操作时间"></el-table-column>

        <el-table-column prop label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <!-- <span @click="selection = scope.row.id, editFormVisible = true">编辑</span>
              <span @click="deleteStudentGroup(scope.row)">删除</span> -->
              <span @click="selection = scope.row.id, editFormVisible = true" title="编辑" class="el-icon-edit icon-style"></span>
              <span @click="deleteStudentGroup(scope.row)" title="删除" class="el-icon-delete icon-style"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="添加学员分组" :visible.sync="addFormVisible" width="30%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-form-item label="分组名称" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入分组名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>

        <el-form-item label="显示排序" prop="sort">
          <el-input
            type="number"
            v-model="addForm.sort"
            placeholder="请输入显示排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addStudentGroup">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑学员分组" :visible.sync="editFormVisible" width="30%" left>
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="分组名称" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入分组名称"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>

        <el-form-item label="显示排序" prop="sort">
          <el-input
            type="number"
            v-model="editForm.sort"
            placeholder="请输入显示排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button size="small" @click="editFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateStudentGroup">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="name" label="题型名称"></el-table-column>
        <el-table-column prop="mode" label="展示模式">
          <template slot-scope="scope">
            <span v-if="scope.row.mode==1">填写模式</span>
            <span v-else>选项模式</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      blockAddStudentGroup: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {},
      addForm: {
        name: "",
        mode: "",
        remark: "",
        mode: 1
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        mode: [
          {
            required: true,
            message: "请输入模式",
            trigger: "blur"
          }
        ],
        remark: []
      },
      editForm: {
        name: "",
        mode: "",
        remark: ""
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字"
          }
        ],
        mode: [
          {
            required: true,
            message: "请输入模式",
            trigger: "blur"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ],
        remark: []
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],

      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      loading: false
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getStudentGroup() {
      this.api.student
        .getStudentGroup({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.agentId = this.loginData.agentId;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.student
        .pageListGroup(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addStudentGroup() {
      if(this.blockAddStudentGroup){
        return false;
      }
      this.blockAddStudentGroup = true;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addForm.agentId = this.loginData.agentId;
          this.api.student
            .addStudentGroup(this.addForm)
            .then(result => {
              this.addFormVisible = false;
              this.blockAddStudentGroup = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateStudentGroup() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.editForm.agentId = this.loginData.agentId;

          this.api.student
            .updateStudentGroup(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteStudentGroup(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.student
            .deleteStudentGroup([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.student
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.student
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getStudentGroup();
      }
    }
  },
  mounted() {
    this.pageList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/grouping/grouping.vue